export const
  SETTING = {
    PLANETARY_SHIELD_BASE: 'PLANETARY_SHIELD_BASE',
    PLANET_STARTING_ORE: 'PLANET_STARTING_ORE',
    PLANET_STARTING_SLOTS: 'PLANET_STARTING_SLOTS',
    PLAYER_PASSIVE_DRAW: 'PLAYER_PASSIVE_DRAW',
    PLAYER_RESUME_CHARGE: 'PLAYER_RESUME_CHARGE',
    REACTOR_RATIO: 'REACTOR_RATIO',
    STRUCT_SWEEP_DELAY: 'STRUCT_SWEEP_DELAY'
  }
;
